export const API_ADMIN = process.env.REACT_APP_API_ADMIN
